// extracted by mini-css-extract-plugin
module.exports = {"Social":"SocialMediaIcon_Social__1lpoP"};